import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as ExportActions from './export.actions';
import { ExportClickedEvent } from './export.models';
import * as ExportSelectors from './export.selectors';

@Injectable()
export class ExportFacade {
  status$ = this.store.pipe(select(ExportSelectors.getExportLoadingStatus));
  documentId$ = this.store.pipe(select(ExportSelectors.getExportDocumentId));
  metaStatus$ = this.store.pipe(select(ExportSelectors.getExportMetaStatus));
  meta$ = this.store.pipe(select(ExportSelectors.getExportMeta));

  constructor(private readonly store: Store) {}

  methodSelectionOpened() {
    this.store.dispatch(ExportActions.methodSelectionOpened());
  }

  mailFormOpened() {
    this.store.dispatch(ExportActions.mailFormOpened());
  }

  download(event: ExportClickedEvent) {
    this.store.dispatch(ExportActions.download(event));
  }

  forward(action: string, documentId?: string) {
    this.store.dispatch(ExportActions.forward({ action, documentId }));
  }

  identifyMeta(event: { documentId: string }) {
    this.store.dispatch(ExportActions.identifyMeta(event));
  }
}
